import React, { ReactNode } from 'react';
import classNames from 'classnames';
import FmSubNavigation from '../FmSubNavigation';
import { NavRoute } from 'models/NavRoutes';

import './DashContentWrapper.styles.scss';
import './DashContentWrapper.styles.responsive.scss';

type DashContentWrapperProps = {
  className?: string;
  children?: ReactNode;
  routes?: NavRoute[];
};

const DashContentWrapper: React.FC<DashContentWrapperProps> = (props) => {
  const { children, className, routes = [] } = props;

  const classes = classNames('dash-content-wrapper', className);

  return (
    <div className={classes}>
      {routes.length > 1 && <FmSubNavigation routes={routes} />}
      <div className="white-content-card-container">{children}</div>
    </div>
  );
};

export default DashContentWrapper;
